// reducers/connect/chat.js

export function connectChatHasErrored(state = false, action) {
  switch (action.type) {
    case 'CONNECT_CHAT_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function connectChatIsLoading(state = false, action) {
  switch (action.type) {
    case 'CONNECT_CHAT_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function connectChat(state = {}, action) {
  switch(action.type) {
    case 'CONNECT_CHAT_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}